module.exports = __webpack_public_path__ + "img/cov-cooperation.b1c76add.jpg";